import classNames from 'classnames'
import { ProductAvailabilityPolicy } from '../../redux-toolkits/products/products.type'

const locationModeOptions: {
  label: string
  description: string
  value: ProductAvailabilityPolicy
}[] = [
  {
    label: 'Inherit from creator',
    description: 'Use the creator availability configured on their profile.',
    value: 'INHERIT_VENDOR',
  },
  {
    label: 'Custom locations',
    description: 'Set product-specific delivery locations and times.',
    value: 'CUSTOM',
  },
]

export const ProductLocationModeSelector = ({
  value,
  onChange,
}: {
  value: ProductAvailabilityPolicy
  onChange: (value: ProductAvailabilityPolicy) => void
}) => {
  return (
    <div
      className="grid w-full grid-cols-1 gap-3 md:grid-cols-2"
      role="radiogroup"
      aria-label="Product location mode"
    >
      {locationModeOptions.map((option) => {
        const active = option.value === value

        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={active}
            className={classNames(
              'flex min-h-[92px] flex-col items-start justify-center rounded-[8px] border px-4 py-3 text-left transition-all',
              active
                ? 'border-black bg-black text-white'
                : 'border-divider-gray bg-white text-black hover:border-black',
            )}
            onClick={() => {
              onChange(option.value)
            }}
          >
            <span className="text-sm font-medium">{option.label}</span>
            <span
              className={classNames('mt-1 text-xs leading-5', {
                'text-light-gray': active,
                'text-sec-black': !active,
              })}
            >
              {option.description}
            </span>
          </button>
        )
      })}
    </div>
  )
}
